/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ThgCreateMessageDtoGen,
  ThgCreateTemplateMessageDtoGen,
  ThgExceptionViewmodelGen,
  ThgMarkMessagesReadDtoGen,
  ThgMessageUsageViewModelGen,
  ThgPageViewModelGen,
  ThgPartnerMessageControllerCreateBatchPayloadGen,
  ThgPartnerMessageControllerCreateFromTemplateParamsGen,
  ThgPartnerMessageControllerFindAllByPartnerIdParamsGen,
  ThgPartnerMessageControllerGetUsageParamsGen,
  ThgPartnerMessageViewModelGen,
  ThgUpdateMessageDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class PartnerMessage<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags PartnerMessage
   * @name PartnerMessageControllerEnsureIndexesAsAdmin
   * @summary (ADMIN) Recreate indexes on message collection
   * @request PATCH:/partner/{partnerId}/message/ensureIndexesAsAdmin
   * @secure
   * @response `200` `void`
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerMessageControllerEnsureIndexesAsAdmin = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<void, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/message/ensureIndexesAsAdmin`,
      method: "PATCH",
      secure: true,
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerMessage
   * @name PartnerMessageControllerCreate
   * @summary Create a message
   * @request POST:/partner/{partnerId}/message
   * @secure
   * @response `200` `ThgPartnerMessageViewModelGen` The created message
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerMessageControllerCreate = (partnerId: string, data: ThgCreateMessageDtoGen, params: RequestParams = {}) =>
    this.http.request<ThgPartnerMessageViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/message`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerMessage
   * @name PartnerMessageControllerFindAllByPartnerId
   * @summary Get all messages for a partner
   * @request GET:/partner/{partnerId}/message
   * @secure
   * @response `200` `(ThgPageViewModelGen & { data?: (ThgPartnerMessageViewModelGen)[] })`
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerMessageControllerFindAllByPartnerId = (
    { partnerId, ...query }: ThgPartnerMessageControllerFindAllByPartnerIdParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgPageViewModelGen & { data?: ThgPartnerMessageViewModelGen[] }, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/message`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerMessage
   * @name PartnerMessageControllerCreateBatch
   * @summary Create a batch of messages
   * @request POST:/partner/{partnerId}/message/batch
   * @secure
   * @response `200` `(ThgPartnerMessageViewModelGen)[]` The created messages
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerMessageControllerCreateBatch = (
    partnerId: string,
    data: ThgPartnerMessageControllerCreateBatchPayloadGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgPartnerMessageViewModelGen[], ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/message/batch`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerMessage
   * @name PartnerMessageControllerGetUsage
   * @summary (Message - READ) Get message usage totals for a partner, split by direction and medium
   * @request GET:/partner/{partnerId}/message/usage
   * @secure
   * @response `200` `ThgMessageUsageViewModelGen` Usage totals for the partner in the requested period
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerMessageControllerGetUsage = (
    { partnerId, ...query }: ThgPartnerMessageControllerGetUsageParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgMessageUsageViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/message/usage`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerMessage
   * @name PartnerMessageControllerFindOneByPartnerId
   * @summary Get a message
   * @request GET:/partner/{partnerId}/message/{id}
   * @secure
   * @response `200` `ThgPartnerMessageViewModelGen` The found message
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerMessageControllerFindOneByPartnerId = (partnerId: string, id: string, params: RequestParams = {}) =>
    this.http.request<ThgPartnerMessageViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/message/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerMessage
   * @name PartnerMessageControllerUpdateOneById
   * @summary Update a message
   * @request PUT:/partner/{partnerId}/message/{id}
   * @secure
   * @response `200` `ThgPartnerMessageViewModelGen` The updated message
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerMessageControllerUpdateOneById = (
    partnerId: string,
    id: string,
    data: ThgUpdateMessageDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgPartnerMessageViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/message/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerMessage
   * @name PartnerMessageControllerGetAttachmentsFromInboundMessage
   * @summary (MESSAGE READ) Gets attachments for an inbound message
   * @request GET:/partner/{partnerId}/message/{id}/attachments
   * @secure
   * @response `200` `File` ZIP file containing the attachments
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerMessageControllerGetAttachmentsFromInboundMessage = (
    partnerId: string,
    id: string,
    params: RequestParams = {}
  ) =>
    this.http.request<File, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/message/${id}/attachments`,
      method: "GET",
      secure: true,
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerMessage
   * @name PartnerMessageControllerMarkManyRead
   * @summary Mark multiple messages as read
   * @request POST:/partner/{partnerId}/message/batch/read
   * @secure
   * @response `200` `number` Number of messages updated
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerMessageControllerMarkManyRead = (
    partnerId: string,
    data: ThgMarkMessagesReadDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<number, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/message/batch/read`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags PartnerMessage
   * @name PartnerMessageControllerCreateFromTemplate
   * @summary Create a message
   * @request POST:/partner/{partnerId}/template/{key}/message
   * @secure
   * @response `200` `ThgPartnerMessageViewModelGen` The created message
   * @response `400` `ThgExceptionViewmodelGen` Bad Request
   * @response `401` `ThgExceptionViewmodelGen` Unauthorized request if token is missing or expired.
   * @response `403` `ThgExceptionViewmodelGen` Forbidden.
   * @response `500` `ThgExceptionViewmodelGen` Internal Server Error
   */
  partnerMessageControllerCreateFromTemplate = (
    { partnerId, key, ...query }: ThgPartnerMessageControllerCreateFromTemplateParamsGen,
    data: ThgCreateTemplateMessageDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<ThgPartnerMessageViewModelGen, ThgExceptionViewmodelGen>({
      path: `/partner/${partnerId}/template/${key}/message`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
